<template>
  <slot :breakpoint="breakpoint" />
</template>

<script setup>
const breakpoint = ref(false);
const cssBodyBefore = window.getComputedStyle(document.body, '::before').getPropertyValue('content');
const checkBreakpoint = () => { breakpoint.value = window.getComputedStyle(document.body, '::before').getPropertyValue('content').replace(/['"]/g, "");}
onMounted(() => {
  checkBreakpoint();
  window.addEventListener('resize', checkBreakpoint);
});
onUnmounted(() => {
  window.removeEventListener('resize', checkBreakpoint);
});
</script>

<style>

/* Make the hidden element hidden */
body:before { display: none; }


/* Wide */
@custom-media --wide screen and (min-width: 1200px);
@media (--wide) {
  body:before {
    content: 'wide';
  }
}

/* Narrow */
@custom-media --narrow screen and (max-width: 1200px) and (orientation: landscape);
@media (--narrow) {
  body:before {
    content: 'narrow';
  }
}

/* Phone */
@custom-media --phone screen and (max-width: 1200px) and (orientation: portrait);
@media (--phone) {
  body:before {
    content: 'phone';
  }
}


</style>
